import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "8a2f93f1-808c-4c26-b2b6-6bdf94a96673",
  publicId: "7",
  name: "Impedance",
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
  difficulty: 1,
};

export default lesson;
